'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactChildrenUtilities = require('react-children-utilities');

var _reactChildrenUtilities2 = _interopRequireDefault(_reactChildrenUtilities);

var _Checkbox = require('../Checkbox/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Group = require('../Group/Group');

var _Group2 = _interopRequireDefault(_Group);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxGroup = function (_Component) {
    _inherits(CheckboxGroup, _Component);

    function CheckboxGroup() {
        _classCallCheck(this, CheckboxGroup);

        var _this = _possibleConstructorReturn(this, (CheckboxGroup.__proto__ || Object.getPrototypeOf(CheckboxGroup)).apply(this, arguments));

        _this.state = {
            value: []
        };
        _this.reset = function () {
            return setTimeout(function () {
                var _this$props = _this.props,
                    value = _this$props.value,
                    defaultValue = _this$props.defaultValue;

                _this.setState({
                    value: value !== undefined ? value : defaultValue
                });
            });
        };
        _this.onCheckboxChange = function (checked, checkboxValue) {
            var currentGroupValue = _this.state.value;
            var _this$props2 = _this.props,
                value = _this$props2.value,
                onChange = _this$props2.onChange;

            var newGroupValue = checked ? [].concat(_toConsumableArray(currentGroupValue), [checkboxValue]) : currentGroupValue.filter(function (v) {
                return v !== checkboxValue;
            });
            _this.setState({ value: value || newGroupValue });
            if (onChange) {
                onChange(newGroupValue);
            }
        };
        _this.renderChildren = function () {
            var _this$props3 = _this.props,
                inline = _this$props3.inline,
                children = _this$props3.children,
                name = _this$props3.name;
            var value = _this.state.value;

            var newProps = {
                name: name,
                checkedValues: value,
                onChange: _this.onCheckboxChange
            };
            return _react2.default.createElement(_Group2.default, { selection: true, inline: inline }, _reactChildrenUtilities2.default.deepMap(children, function (child) {
                return child.type === _Checkbox2.default ? _react2.default.cloneElement(child, newProps) : child;
            }));
        };
        _this.componentWillReceiveProps = function (newProps) {
            if (newProps.value) {
                _this.setState({
                    value: newProps.value
                });
            }
        };
        _this.assignNode = function (node) {
            _this.groupNode = node;
        };
        return _this;
    }

    _createClass(CheckboxGroup, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                value = _props.value,
                defaultValue = _props.defaultValue;

            this.setState({
                value: value || defaultValue || []
            });
            if (!this.groupNode) {
                return;
            }
            var firstGroupInput = this.groupNode.querySelector('input');
            this.formNode = firstGroupInput ? firstGroupInput.form : null;
            if (this.formNode) {
                this.formNode.addEventListener('reset', this.reset, false);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.formNode) {
                this.formNode.removeEventListener('reset', this.reset);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                labelClassName = _props2.labelClassName,
                label = _props2.label,
                tooltip = _props2.tooltip;

            return _react2.default.createElement("div", { className: "luna-form__field", ref: this.assignNode }, label && _react2.default.createElement("label", { className: 'luna-label ' + labelClassName }, _react2.default.createElement("strong", null, label)), tooltip, this.renderChildren());
        }
    }]);

    return CheckboxGroup;
}(_react.Component);

exports.default = CheckboxGroup;

CheckboxGroup.propTypes = {
    labelClassName: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    defaultValue: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object])).isRequired,
    value: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.number, _propTypes2.default.object])),
    onChange: _propTypes2.default.func.isRequired,
    children: _propTypes2.default.node.isRequired,
    label: _propTypes2.default.node.isRequired,
    inline: _propTypes2.default.bool,
    tooltip: _propTypes2.default.node
};
CheckboxGroup.defaultProps = {
    labelClassName: '',
    inline: false
};
//# sourceMappingURL=CheckboxGroup.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/CheckboxGroup/CheckboxGroup.js